/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/debugLog.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/debugLog', exports: {} }; const exports = module.exports;

const mockable = {
    events: []
}
function push(level) {
    const args = [].slice.call(this);
    if (!args.length) {
        return;
    }
    const event = {
        level,
        values: args.length === 1 ? args[0] : args,
    };
    return mockable.events.push(event);
}
function clear() {
    mockable.events.splice(0);
}
window.Fandango.debugLogDevs = {
    get() {
        return mockable.events;
    },
    set(events) {
        mockable.events = events;
    }
};
export default Object.assign(mockable, {
    log() {
        push.call(arguments, 'log');
    },
    info() {
        push.call(arguments, 'info');
    },
    error() {
        push.call(arguments, 'error');
    },
    warn() {
        push.call(arguments, 'warn');
    },
    clear
});